<template>
  <div class="ProjectInfo">
    <ComBox
      title="AI行为告警"
      :element="element"
    >
      <div
        class="info"
        :style="`top: ${changeDevicePixelRatio(42)}px;`"
      >
        <div :class="`${element.style.direction}`">
          <div class="list">
            <div
              v-for="(item,index) in arRecordList"
              :key="item.recordId"
              class="item"
              :class="{first:index===0}"
              :style="`margin-bottom: ${changeDevicePixelRatio(
                10
              )}px;border-radius: ${changeDevicePixelRatio(10)}px;`"
            >
              <div class="img">
                <img
                  :src="item.alarmPhotoUrl || personAvatar"
                  alt=""
                />
              </div>
              <div class="detail">

                <div class="userInfo">
                  <div class="txt ">
                    {{ item.channelName }}</div>
                  <div class="txt ">
                    {{ item.alarmTime }}</div>
                </div>
                <div class="idenInfo">
                  <div class="txt ">
                    {{ item.alarmTypeName }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
import ComBox from '../ComBox.vue'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'

export default {
  components: { ComBox },
  props: {
    arRecordList: {
      type: Array,
      default: () => {
        const list = []
        for (let index = 0; index < 20; index++) {
          list.push({
            alarmTypeName: '未戴安全帽',
            alarmTime: '2023-05-20 12:00:00',
            channelName: '通道名称',
            alarmPhotoUrl: ''
          })
        }
        return list
      }
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      personAvatar: require('../../../../../../assets/images/new-screen/u24316.png')
    }
  },
  computed: {
    listFontSize() {
      const px = Math.ceil(12 / window.devicePixelRatio)
      return px
    }
  },
  created() {},

  methods: {
    changeDevicePixelRatio
  }
}
</script>

<style lang="scss" scoped>
.ProjectInfo {
  width: 414px;
  height: 590px;
  position: relative;
  .info {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    .vertical {
      .list {
        color: #fff;
        .item {
          background: #0d3888;
          margin: 0 3%;
          margin-bottom: 10px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          padding: 4%;
          text-align: right;
          .img {
            width: 40%;
            padding-bottom: 25%;
            flex-shrink: 0;
            position: relative;
            img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
            }
          }
          .detail {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .idenInfo {
              color: #ff0000;
              .txt {
                margin-bottom: 0;
              }
            }
            .txt {
              line-height: 1;
              margin-bottom: 8%;
            }
          }
        }
        .first {
          display: block;
          .img {
            width: 100%;
            padding-bottom: 38%;
          }
          .detail {
            flex: 1;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            margin-top: 5%;
            .userInfo {
              text-align: left;
            }
            .idenInfo {
              display: flex;
              align-items: flex-end;
            }
            .txt {
              margin-bottom: 0;
              line-height: 1.4;
            }
          }
        }
      }
    }
    .horizontal {
      width: 100%;

      .list {
        display: flex;
        width: 100%;
        overflow-x: auto;
        .item {
          width: 31%;
          max-width: 200px;
          flex-shrink: 0;
          background: #0d3888;
          margin: 0 1%;
          border-radius: 10px;
          // padding: 2%;
          .img {
            width: 92%;
            padding-bottom: 70%;
            position: relative;
            margin: 0 auto;
            margin-top: 4%;
            img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
            }
          }
          .detail {
            line-height: 1.2;
            padding: 4%;
            .idenInfo {
              color: #ff0000;
            }
          }
        }
      }
    }
  }
}
</style>
